(function ($) {
    $(document).ready(function () {
        var modalButton = $("[data-lity]");
        modalButton.on("click", function (e) {
            e.preventDefault();
        });
    });
})(jQuery);
